'use client'

import React, { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, BoxProps, Flex, Text, useDisclosure } from '@chakra-ui/react'

import { VideoModal } from 'components/ui/VideoModal'
import { formatVideoLength } from 'utils/formatVideoLength'

import { VideoThumbnailImg, VideoThumbnailPlayButton, VideoThumbnailWrapper } from './styles'

type Props = {
  videoThumbnailUrl: string | null
  videoTitle: string | null
  videoLength: string | null
  videoUrl: string
  isDark?: boolean
} & BoxProps

export const VideoPreview = ({
  videoThumbnailUrl,
  videoTitle,
  videoLength,
  videoUrl,
  isDark = true,
  ...boxProps
}: Props): JSX.Element | null => {
  const { t } = useTranslation('common')
  const { open, onOpen, onClose } = useDisclosure({ defaultOpen: false })

  if (!videoTitle || !videoThumbnailUrl) {
    return null
  }

  return (
    <Box {...boxProps}>
      <Text marginY="12px" fontWeight="semibold">
        {t('watchHowToVideo')}
      </Text>
      <Flex align="start" flexDirection="column">
        <VideoThumbnailWrapper onClick={onOpen}>
          <VideoThumbnailImg src={videoThumbnailUrl} alt="product video thumbnail" />
          <VideoThumbnailPlayButton src="/icons/play-button-overlay.svg" alt="Play" />
        </VideoThumbnailWrapper>
        <Box marginTop="12px">
          <Text
            color={isDark ? 'black' : 'white'}
            fontSize="xs"
            fontWeight="normal"
            lineHeight="12px"
            marginBottom="6px"
          >
            {videoTitle}
          </Text>
          {videoLength && (
            <Text color={isDark ? 'green.a200' : 'green.a250'} fontSize="xs" fontWeight="700">
              {formatVideoLength(videoLength)}
            </Text>
          )}
        </Box>
      </Flex>
      <VideoModal
        isOpen={open}
        onClose={onClose}
        videoUrl={videoUrl}
        videoTitle={videoTitle}
        videoLength={videoLength}
      />
    </Box>
  )
}
